import React from "react";

function LineLogs({ log, onDetailsClick }) {
  function formatDateLogs(timestamp) {
    // Assurez-vous que timestamp est un objet Firestore Timestamp
    // et convertissez-le en objet Date JavaScript
    const date = timestamp.toDate();

    // Retourne la date formatée comme une chaîne de caractères
    // Modifiez les options selon vos besoins pour le format de la date et de l'heure
    return date.toLocaleString("en-EN", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  return (
    <div className="line-detail-logs">
      <div>
        Record by :{" "}
        <span
          style={{
            fontSize: "18px",
            fontWeight: "600",
            color: "#007bff",
            paddingLeft: "5px",
          }}
        >
          {log.recordedBy}
        </span>{" "}
        , on{" "}
        <span
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#007bff",
            paddingLeft: "5px",
          }}
        >
          {formatDateLogs(log.recordedAt)}
        </span>
      </div>
      <div style={{ paddingRight: "20px" }}>
        <div className="logs-detail-button" onClick={() => onDetailsClick(log)}>
          Details
        </div>
      </div>
    </div>
  );
}

export default LineLogs;
